import { useEffect, useState } from "react";
import { Mode } from "@/enum";

interface BottomBarProps {
  whitelistEndTime: string | number | Date;
  mode: Mode;
  onModeChange: (mode: Mode) => void;
}

export default function BottomBar({
  whitelistEndTime,
  mode,
  onModeChange,
}: BottomBarProps) {
  const [isWhitelistOver, setIsWhitelistOver] = useState(false);

  useEffect(() => {
    const end = new Date(whitelistEndTime).getTime();

    const update = () => {
      const now = Date.now();
      setIsWhitelistOver(now >= end);
    };

    update();
    const t = setInterval(update, 1000);
    return () => clearInterval(t);
  }, [whitelistEndTime]);

  const { Mint, Whitelist, Verse } = Mode;

  return (
    <div className="bottom-bar-wrapper">
      <button
        className={`button-flat bottom-bar-primary ${
          isWhitelistOver ? "mint-now" : ""
        }`}
        disabled={isWhitelistOver ? mode === Mint : mode === Whitelist}
        onClick={() => onModeChange(isWhitelistOver ? Mint : Whitelist)}
      >
        {isWhitelistOver ? "Mint Now" : "Join Whitelist"}
      </button>

      <button
        className="button-flat bottom-bar-secondary"
        disabled={mode === Verse}
        onClick={() => onModeChange(Verse)}
      >
        Warplet Verse
      </button>
    </div>
  );
}
